/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";
import * as Modals from "../modals";
import { formatYearMonth2, makeDates, formatdate, defaultProps} from "../../util/DateUtil";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { openlightbox } from "../../util/Functions";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { allStatus, partners, noDataComponent } from "../../util/DataObject"
import { ScheduleSend } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useStyles } from "../../util/ComponentStyles"
import MonthPicker from "@9softstudio/react-monthpicker";
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import moment from "moment";
import "moment/locale/es";

const ReportCards = (props) => {
  const clasess = useStyles();
  const [statusCard, setStatusCard] = useState("");
  const [filterDate, setFilterDate] = useState([
    props.content.startDate,
    props.content.endDate,
  ]);

  const [limit, setLimit] = useState(50);
  const [oldData, setOldData] = useState([]);
  const [total, setTotal] = useState(0);
  const [totals, setTotals] = useState({
    total_confirmed: 0,
    total_customizing: 0,
    total_on_hold: 0,
    total_on_transit: 0,
    total_ordered: 0,
    total_received: 0,
    total_sent: 0,
    total_on_report: 0,
    total_unassigned: 0,
  });
  const [partner, setPartner] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [tabSelect, setTabSelect] = useState("retail");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const history = useHistory();

  const init = () => {
    setSearch("");
    setTotal(props.content.total);
    setTotalPage(props.content.totalPage);
    setData(props.content.cards);
    setOldData(props.content.cards);
    setPage(props.content.page);
    setPages(props.content.pages);
    if (props.content.totals) {
      setTotals(JSON.parse(JSON.stringify(props.content.totals)));
    }
  };

  useEffect(() => {
    init();
  }, [props.content]);
  moment.locale("es");
  let a;

  // Filter Date --------------------------------------
  const changeMonth = async (month, year) => {
    const yearMonth = formatYearMonth2(month, year);
    a = makeDates(yearMonth);
    setFilterDate(makeDates(yearMonth));
    setSearch("");
    setStatusCard("");

    props.changeLoader(true);
    let data = {
      resultsPerPage: limit,
      pageNumber: 1,
      type_card: tabSelect,
      genericFilters: [],
    };

    data.genericFilters.push({ start_date: a[0] });
    data.genericFilters.push({ end_date: a[1] });

    if (partner && partner !== "Todos") {
      data.genericFilters.push({ partner: partner });
    }

    let request = await API.service( "reportCards", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      request.data.data.widget[0]["content"]["totals"] = request.data.data
        .widget[0]["content"]["totals"]
        ? request.data.data.widget[0]["content"]["totals"]
        : props.content.totals;
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  // Filter Type --------------------------------------
  const filterType = async (type) => {
    setStatusCard("");
    setSearch("");

    if (type == tabSelect) {
      setTabSelect("");
      setData(JSON.parse(JSON.stringify(oldData)));
    } else {
      setStatusCard("");
      setSearch("");
      setPartner("");
      props.changeLoader(true);
      let data = {
        resultsPerPage: limit,
        pageNumber: 1,
        type_card: type,
        genericFilters: [],
      };

      data.genericFilters.push({ start_date: filterDate[0] });
      data.genericFilters.push({ end_date: filterDate[1] });

      let request = await API.service( "reportCards", data, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == "OK") {
        request.data.data.widget[0]["content"]["totals"] = request.data.data
          .widget[0]["content"]["totals"]
          ? request.data.data.widget[0]["content"]["totals"]
          : props.content.totals;
        props.changeWidgets(request.data.data.widget);
      }
      props.changeLoader(false);
      setTabSelect(type);
      props.changeLoader(false);
    }
  };

  // Filter Cards --------------------------------------
  const findCards = async (execute) => {
    props.changeLoader(true);
    let data = {
      resultsPerPage: totalPage,
      pageNumber: page,
      genericFilters: [],
    };
    data.genericFilters.push({ start_date: filterDate[0] });
    data.genericFilters.push({ end_date: filterDate[1] });

    if (statusCard && statusCard !== "Todos") {
      data.genericFilters.push({ status: statusCard });
    } else if (tabSelect) {
      data["type_card"] = tabSelect;
    } else if (filterDate) {
      data.genericFilters.push({ start_date: filterDate[0] });
      data.genericFilters.push({ end_date: filterDate[1] });
    }
    if (partner && partner !== "Todos") {
      data.genericFilters.push({ partner: partner });
    }
    if (execute == "next") {
      data.pageNumber = page + 1;
    }
    if (execute == "prev") {
      data.pageNumber = page - 1;
    }
    props.changeLoader(true);

    let request = await API.service( "reportCards", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      request.data.data.widget[0]["content"]["totals"] = request.data.data
        .widget[0]["content"]["totals"]
        ? request.data.data.widget[0]["content"]["totals"]
        : props.content.totals;
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  // Filter Status --------------------------------------
  const filterDataEstatus = async (e) => {
    setSearch("");
    setStatusCard(e.target.value);

    props.changeLoader(true);
    let data = {
      resultsPerPage: limit,
      pageNumber: 1,
      type_card: tabSelect,
      genericFilters: [],
    };

    if (e.target.value !== "Todos") {
      data.genericFilters.push({ status: e.target.value });
    }
    if (partner && partner !== "Todos") {
      data.genericFilters.push({ partner: partner });
    }
    if (filterDate) {
      data.genericFilters.push({ start_date: filterDate[0] });
      data.genericFilters.push({ end_date: filterDate[1] });
    }

    let request = await API.service( "reportCards", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      request.data.data.widget[0]["content"]["totals"] = request.data.data
        .widget[0]["content"]["totals"]
        ? request.data.data.widget[0]["content"]["totals"]
        : props.content.totals;
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  // Filter Partner --------------------------------------
  const changePartner = async (e) => {
    setSearch("");
    setPartner(e.target?.value);
    let p = e.target?.value;

    props.changeLoader(true);
    let data = {
      resultsPerPage: limit,
      pageNumber: 1,
      type_card: tabSelect,
      genericFilters: [],
    };

    if(p !== "Todos"){
      data.genericFilters.push({ partner: p });
    }

    if (statusCard && statusCard !== "Todos") {
      data.genericFilters.push({ status: statusCard });
    }
    if (filterDate) {
      data.genericFilters.push({ start_date: filterDate[0] });
      data.genericFilters.push({ end_date: filterDate[1] });
    }

    let request = await API.service( "reportCards", data, props.pos, props.changeAlert, props.changeLoader, history);   
    if (request.status == 200 && request.data.data.response == "OK") {
      request.data.data.widget[0]["content"]["totals"] = request.data.data
        .widget[0]["content"]["totals"]
        ? request.data.data.widget[0]["content"]["totals"]
        : props.content.totals;
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  // Download Report ------------------------------------
  const download = async () => {
    props.changeLoader(true);    
    
    let request = await API.service( "downloadReport", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.data.data.response == "OK" && request.status == 200) {
      if (request.data.data.content) {
        let url = request.data.data.content;
        window.open(url, "_blank");

        props.changeLoader(false);
        props.changeAlert(true, "success", "Reporte descargado con éxito");
        return;
      }
    } else {
      props.changeLoader(false);
      props.changeAlert(true, "error", "Error en descarga de reporte");
    }
  };

  // Functions ------------------------------------------
  const getTracking = (item) => {
    let trackingNumber = "";
    if (item.hasOwnProperty("tracking") && item.tracking.hasOwnProperty("tracking_number_shipping")) {
      trackingNumber = item["tracking"]["tracking_number_shipping"];
    }
    return trackingNumber;
  };

  const changeText = (e) => {
    setSearch(e.target.value);
  };

  const filterData = () => {
    setStatusCard("");

    let d = oldData;
    let filterD = [];
    if (search) {
      for (let i = 0; i < d.length; i++) {
        if (d[i]["customer"]["name"].toLowerCase().indexOf(search.toLocaleLowerCase()) > -1 ||
          d[i]["customer"]["email"].indexOf(search) > -1 ||
          d[i]["customer"]["phone"].indexOf(search) > -1 ) {
          filterD.push(d[i]);
        } else {
          if (d[i].hasOwnProperty("tracking") &&
            d[i]["tracking"]["tracking_number_shipping"] &&
            d[i]["tracking"]["tracking_number_shipping"].indexOf(search) > -1 ) {
            filterD.push(d[i]);
          }
        }
      }
      setData(JSON.parse(JSON.stringify(filterD)));
    } else {
      setData(JSON.parse(JSON.stringify(oldData)));
    }
  };

  const presDown = (e) => {
    if (e.key == "Enter") {
      filterData();
    }
  };

  const hasAction = (action) => {
    return props.widgets[0].config?.actions?.indexOf(action) > -1;
  };

  const openDetail = async (item) => {
    let contentModal = {
      title: item.customer.name,
      content: item,
      data: data,
    };

    const as = (
      <Modals.ReportCardDetail
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        contentModal={contentModal}
        pos={props.pos}
        key="reportCardDetail"
      />
    );
    openlightbox(as);
  };

  const editStatus = async (item, e) => {    
    props.changeLoader(true);   
    let data = {
      card_uuid: item.uuid,
      status: e.target.value,
    }; 
    
    let request = await API.service( "cardStatusUpdate", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.data.data.response == "OK" && request.status == 200) {
      await findCards(tabSelect)
      props.changeLoader(false);
      props.changeAlert(true, "success", "Estatus actualizado con éxito");
      return;
      
    } else {
      let detail = request.data.data.message;
      props.changeLoader(false);
      props.changeAlert(true, "error", "Error al editar el estatus, " + detail);
    }
  };

  const columns = [
    { cell: (item) => {
        return (<div><a href="#" data-tag="allowRowEvents" onClick={openDetail.bind(this, item)} ><VisibilityIcon /></a></div> );
      },
      sortable: true, maxWidth: "50px", minWidth: "50px",
    },
    { selector: (row) => row.customer.name, name: "Nombre", minWidth: tabSelect === "aBB" ? "11%" : "15%", sortable: true, wrap: true},
    { selector: (row) => row.customer.email, name: "Correo", minWidth: tabSelect === "aBB" ? "19%" : "26%", sortable: true, wrap: true},
    { selector: (row) => row.customer.phone, name: "Teléfono", minWidth: tabSelect === "aBB" ? "14%" : "14%", sortable: true, wrap: true},
    { selector: (row) => moment(new Date(row.cdate)).format("L"), name: "Solicitud", width: tabSelect === "aBB" ? "10%" : "11%", sortable: true},
    { cell: (row) => {
      return (       
        <select value={row.status_key} onChange={editStatus.bind(this, row)} disabled={row.status == "disabled" ? true : false}>
          { allStatus.map((item, index) => {
              if(item.label !== "Todos"){
                return (
                  <option key={`state-${index}`} value={item.key}>
                    {item.label}
                  </option>
                )
              }
          })}
        </select>
      )},
      name: "Estatus", wrap: true, width: tabSelect === "aBB" ? "12%" : "15%", sortable: true
    },

    { selector: (row) => getTracking(row), name: "Guía", minWidth: tabSelect === "aBB" ? "8%" : "12%", sortable: true, wrap: true},
    { cell: (row) => { return tabSelect === "aBB" ? <div>{row.suitcase_uuid}</div> : <></> },
      name: tabSelect === "aBB" ? "SuitecaseID" : "", minWidth: tabSelect === "aBB" ? "21%" : "0%", sortable: true, wrap: true},
  ];

  return (
    <div className="size-12">

      <div className="size-12">
        <div className="card">
          <Typography
            component="div"
            className="dataWidget"
            style={{textAlign: "center"}}
            children={
              allStatus.map((i) => {
                if(totals.hasOwnProperty("total_" + i.key)){
                  return (
                    <div key={i.key} className="resultInItem">
                      <span className="neutral">{i.label[i.label.length -1] === "a" ? i.label + "s" : i.label}</span>
                      <br /><strong>{totals["total_" + i.key]}</strong>
                    </div>
                  )
                }
            })}
          />
        </div>
      </div>

      <div className="size-12">
      <div className="tabBox card dataBlock">
        <div className="form-row">
          <div className="col-12 form-report-head">
            <Typography
              component="div"
              children={
                <div className={clasess.titleTable}>
                  <h2 className={clasess.titleH2}>
                    <ScheduleSend className={clasess.iconTitle} />
                    Reporte de Seguimientos
                  </h2>              
                </div>
              }
            />
            <div className="form-row">
              <div
                className="inputIconRight"
                style={{ width: "374px", marginRight: "7px" }}
              >
                <input
                  type="text"
                  className="ibon-account"
                  placeholder="Nombre, telefono, email, guia"
                  value={search}
                  onChange={changeText.bind(this)}
                  onKeyDown={presDown.bind(this)}
                />
                <i className="ibon-search tap" onClick={filterData.bind(this)} />
              </div>
              {hasAction("download") && (
                <div className="bigButton padding-right desktop">
                  <button style={{ padding: "6px" }} onClick={download}>
                    Descargar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-12  inputIconRight fx-pnl-aprtr">
            <div className="row pos-right">
              <div className="tableToolsCargo fx-pnl-apertura"></div>
            </div>

            <div className="tableToolsAbonos fx-tableCalendar-1">
              <MonthPicker
                onSelect={changeMonth.bind(this)}
                monthNames={defaultProps.monthNames}
                hasRange={true}
                onFormat={formatdate}
                isReadonly={true}
                minMonth={10}
                minYear={2006}
                iconElement={
                  <i className="ibon-calendar icon-calendar-pos-tbl"/>
                }
              />
            </div>

            <div className="tableToolsAbonos desktop fx-tableTipoMov">
              <select
                value={statusCard}
                onChange={filterDataEstatus.bind(this)}
                style={{ marginRight: "7px", padding: "5px" }}
              >
                <option value={""} key={null} disabled hidden>
                  Estatus
                </option>
                {allStatus.map((item, index) => {
                  if(tabSelect !== "aBB" && item.key === "unassigned"){
                    return
                  } else {
                    return (
                      <option value={item.key} key={index}>
                        {item.label}
                      </option>
                    );
                  }
                })}
              </select>

              <select value={partner} onChange={changePartner.bind(this)} style={{ padding: "5px" }}>
                <option value={""} key={null} disabled hidden>
                  Partner
                </option>
                {partners.map((item, index) => {
                  return (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>

        <div className="form-row form-report">
          <div className="tableTools">
            {!search && (
              <div className="tableToolspages fix-pag-tbl">
                <span className="neutral">
                  {page === 1 ? 0 : (page - 1) * totalPage + 1} -{" "}
                  {totalPage * page >= total ? total : totalPage * page} de{" "}
                  {total}
                </span>
                {page > 1 && (
                  <i className="tap ibon-chevron-left indigo" onClick={findCards.bind(this, "prev")} />
                )}
                {page < pages && (
                  <i className="tap ibon-chevron-right indigo" onClick={findCards.bind(this, "next")} />
                )}
              </div>
            )}
            {search && (
              <div className="tableToolspages fix-pag-tbl">
                <span className="neutral">
                  0 - {data.length} de {data.length}
                </span>
                {page > 1 && (
                  <i className="tap ibon-chevron-left indigo" onClick={findCards.bind(this, "prev")} />
                )}
                {page < pages && (
                  <i className="tap ibon-chevron-right indigo" onClick={findCards.bind(this, "next")} />
                )}
              </div>
            )}
          </div>
        </div>
        <ul>
          <li onClick={filterType.bind(this, "retail")} className={tabSelect == "retail" ? "active" : ""} >
            Retail
          </li>
          <li onClick={filterType.bind(this, "aBB")} className={tabSelect == "aBB" ? "active" : ""} >
            afB
          </li>
        </ul>
        <div style={{ width: "100%", margin: "auto" }}>
          <ThemeProvider theme={theme}>
            <DataTable
              columns={columns}
              data={data}
              customStyles={customStyles2}
              noDataComponent={noDataComponent}
            />
          </ThemeProvider>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ReportCards;
